import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'

const DetailedTutorInfoCardSkeleton = ({
  iconSection,
  nameSection,
  loginSection,
  lessonsSection,
  languagesSection,
  linkSection,
}) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      p="2x"
      bg="white100"
      borderRadius="1x"
    >
      <Box width="100%">{iconSection}</Box>
      <Box sx={{ textAlign: 'center' }}>{nameSection}</Box>
      <Box>{loginSection}</Box>
      {lessonsSection && <Box mt="1x">{lessonsSection}</Box>}
      {languagesSection && (
        <Box mt="1x">{languagesSection && languagesSection}</Box>
      )}
      <Box mt="2x">{linkSection}</Box>
    </Flex>
  )
}

DetailedTutorInfoCardSkeleton.propTypes = {
  iconSection: PropTypes.any,
  nameSection: PropTypes.any,
  loginSection: PropTypes.any,
  lessonsSection: PropTypes.any,
  languagesSection: PropTypes.any,
  linkSection: PropTypes.any,
}

export default DetailedTutorInfoCardSkeleton
